module.exports = __webpack_public_path__ + "assets/c8d8a3fc31d2bf8b93e6bf9cf13a72b3.png";